import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { OpcCredentialsPage } from 'components/pages/OpcCredentialsPage/OpcCredentialsPage';
import { OpcViewPage } from 'components/pages/OpcViewPage/OpcViewPage';

export const OpcRoutes = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}>
                {/*Redirect to view page as default.*/}
                <Redirect to={`${path}/view`} />
            </Route>
            <Route path={`${path}/create`} component={OpcCredentialsPage} />
            <Route path={`${path}/view`} component={OpcViewPage} />
            <Route path={`${path}/edit`} component={OpcCredentialsPage} />
        </Switch>
    );
};
